<template>
  <el-dialog
    :visible.sync="display"
    :modal-append-to-body="false"
    :title="$t('SubscriptionLogsPopup_Title')"
    width="400"
    center
  >
    <rest-list
      v-if="display"
      :payload="fetchEndpoint"
      ref="list"
      :filterable="false"
      :outline="false"
    >
      <rest-list-column prop="method" title="Method" :width="200" />

      <rest-list-column prop="status" title="Status" :width="200">
        <template slot-scope="{ row }">
          <div class="status-container">
            <i
              :class="getSubscriptionIcon(row.status) || 'el-icon-empty-icon'"
            ></i>
            {{ getSubscriptionLabel(row.status) }}
          </div>
        </template>
      </rest-list-column>

      <rest-list-column-date prop="time" title="Timestamp" />
    </rest-list>
  </el-dialog>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint } from '@/core/helpers'
import RestListColumnDate from '../../../common/components/rest/RestListColumnDate'
import { subscriptionStatusKeys } from '@/modules/profiles/enum/SubscriptionStatusEnum'

export default {
  name: 'SubscriptionLogsPopup',

  components: {
    RestListColumnDate,
    RestList,
    RestListColumn
  },

  data() {
    return {
      display: false,
      channel: ''
    }
  },

  props: {
    profileId: {
      type: String
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.profileId}/subscription-logs`,
        params: {
          channel: this.channel,
          profile_id: this.profileId
        }
      })
    }
  },

  methods: {
    show(channel) {
      this.channel = channel
      this.display = true
    },

    getSubscriptionIcon(value) {
      if (value === subscriptionStatusKeys.Unsubscribed) {
        return 'el-icon-error'
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return 'el-icon-success'
      } else if (value === null) {
        return undefined
      }
    },

    getSubscriptionLabel(value) {
      if (value === subscriptionStatusKeys.Unsubscribed) {
        return this.$t('Profiles_Channels_StatusUnsubscribed')
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return this.$t('Profiles_Channels_StatusSubscribed')
      } else if (value === null) {
        return this.$t('Profiles_Channels_StatusNotProvided')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-container {
  display: flex;
  align-items: center;

  i {
    font-size: 18px;
    margin-right: 10px;
  }

  .el-icon-success {
    color: #1fca10;
  }

  .el-icon-error {
    color: #f56c6c;
  }

  .el-icon-empty-icon {
    background: #e6e6e6;
    width: 18px;
    height: 18px;
    border-radius: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/SubscriptionLogsPopup.vue